import { StatusIndicator, useAssetTranslation } from '@mss/mss-component-library';

const REMOTE_ACCESS_NS = { ns: 'remoteAccess' as const };
const RequestStatus = ({ status }: any) => {
  const { t } = useAssetTranslation();
  if (typeof status !== 'string') return null;
  switch (status.toLowerCase()) {
    case 'awaiting_approval':
      return (
        <>
          <StatusIndicator variant="yellow" /> {t('Awaiting approval')}
        </>
      );
    case 'allow':
      return (
        <>
          <StatusIndicator variant="green" /> {t('Approved')}
        </>
      );
    case 'denied':
      return (
        <>
          <StatusIndicator variant="red" /> {t('Denied')}
        </>
      );
    case 'revoked':
      return (
        <>
          <StatusIndicator variant="red" /> {t('Revoked')}
        </>
      );
    case 'wait_for_start_date':
      return (
        <>
          <StatusIndicator variant="green" />{' '}
          {t('Future approved', REMOTE_ACCESS_NS)}
        </>
      );
    case 'expired':
      return (
        <>
          <StatusIndicator variant="red" /> {t('Expired', REMOTE_ACCESS_NS)}
        </>
      );
    case 'expired_unapproved':
      return (
        <>
          <StatusIndicator variant="red" /> {t('Expired approval', REMOTE_ACCESS_NS)}
        </>
      );
    default:
      return null;
  }
};

export default RequestStatus;
